import React, { useState, useEffect } from "react";
import classNames from "classnames";

/**
 * Font aliases mapping:
 * - montserrat -> Montserrat (Main text font)
 * - sackers -> Sackers Gothic Std (Title font)
 */
const FONT_CONFIGS = {
  montserrat: "24px 'Montserrat'",
  sackers: "24px 'Sackers Gothic Std'",
};

const Skeleton = ({
  children,
  width = "fit-content",
  isLoaded = true,
  byFonts = false,
  dark = false,
  display = "div",
}) => {
  const [isFontLoaded, setIsFontLoaded] = useState(false);

  useEffect(() => {
    if (!byFonts) {
      setIsFontLoaded(true);
      return;
    }

    // Check if fonts API is supported
    if (!document.fonts) {
      setIsFontLoaded(true);
      return;
    }

    const fontToCheck = FONT_CONFIGS[byFonts];
    if (!fontToCheck) {
      console.warn(`Unknown font alias: ${byFonts}`);
      setIsFontLoaded(true);
      return;
    }

    // Handler for fonts loading completion
    const handleLoadingDone = () => {
      if (document.fonts.check(fontToCheck)) {
        setIsFontLoaded(true);
        document.fonts.removeEventListener("loadingdone", handleLoadingDone);
      }
    };

    // Add event listener for fonts loading
    document.fonts.addEventListener("loadingdone", handleLoadingDone);

    // Initial check in case font is already loaded
    handleLoadingDone();

    // Cleanup
    return () => {
      document.fonts.removeEventListener("loadingdone", handleLoadingDone);
    };
  }, [byFonts]);

  if ((byFonts && isFontLoaded && isLoaded) || (!byFonts && isLoaded)) {
    return children;
  }

  const Tag = display === "div" ? "div" : "span";

  return (
    <Tag
      className={classNames("skeleton", {
        "skeleton--dark": dark,
        [`skeleton--${width}`]: width,
      })}
      aria-hidden="true"
    >
      {children}
    </Tag>
  );
};

export default Skeleton;
